export interface RatingFormData {
  target: 'EXTRA' | 'ORG';
  ratee: { name: string };
  alreadyRated: boolean;
  criteria: { code: string; label: string; description: string | null; auto: { score: number; minutesLate: number } | null }[];
  tags: { code: string; emoji: string | null; label: string; polarity: 'POSITIVE' | 'NEGATIVE' }[];
  lowScoreThreshold: number;
  revealAfterDays: number;
}

export interface PublicRating {
  score: number | null;
  count: number;
  isNew: boolean;
  topTags: { code: string; emoji: string | null; label: string; count: number }[];
}

export interface Feedback {
  score: number | null;
  average: number | null;
  count: number;
  isNew: boolean;
  criteria: { code: string; label: string; average: number; count: number }[];
  tags: { code: string; emoji: string | null; label: string; polarity: 'POSITIVE' | 'NEGATIVE'; count: number }[];
  recent: { id: string; createdAt: string; average: number; comment: string | null }[];
}

export interface IncidentView {
  id: string;
  kind: 'NO_SHOW' | 'EARLY_DEPARTURE';
  status: 'OPEN' | 'CONFIRMED' | 'DISMISSED';
  note: string | null;
  actualEnd: string | null;
  response: string | null;
  decisionNote: string | null;
  createdAt: string;
  missionTitle: string;
  missionStartsAt: string;
  organizationName: string;
}

export const INCIDENT_LABELS = { NO_SHOW: 'Absence non justifiée', EARLY_DEPARTURE: 'Départ avant la fin prévue' } as const;

export interface Reliability {
  reliabilityPct: number | null;
  onTimePct: number | null;
  honored: number;
  lastMinuteCancels: number;
  noShows: number;
  topExtra: boolean;
}

export interface HoursSnapshot {
  plannedMinutes: number;
  actualMinutes: number | null;
  differenceMinutes: number | null;
  toleranceMinutes: number;
  divergent: boolean;
  hourlyRateCents: number;
  dispute: {
    id: string;
    kind: 'MORE' | 'LESS';
    status: 'OPEN' | 'RESOLVED';
    plannedMinutes: number;
    actualMinutes: number;
    orgNote: string | null;
    extraNote: string | null;
    billableMinutes: number | null;
    resolution: 'AGREED_PLANNED' | 'AGREED_ACTUAL' | 'SUPPORT' | null;
    decisionNote: string | null;
  } | null;
}

export const fmtMinutes = (m: number) => `${Math.floor(Math.abs(m) / 60)} h ${String(Math.abs(m) % 60).padStart(2, '0')}`;
